import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HeaderCreditsService {
  private creditReserveSubject = new Subject<number>();
  private bonusReserveSubject = new Subject<number>();
  private bonusBalanceSubject = new Subject<number>();
  private profilePictureSubject = new Subject<string>();

  private creditAssignedSuccessSource = new Subject<void>();
  creditAssignedSuccess$ = this.creditAssignedSuccessSource.asObservable();

  creditReserve = this.creditReserveSubject.asObservable();
  bonusReserve = this.bonusReserveSubject.asObservable();
  profilePicture = this.profilePictureSubject.asObservable();
  bonusBalance = this.bonusBalanceSubject.asObservable();

  setCreditReserve(creditReserve: number) {
    this.creditReserveSubject.next(creditReserve);
  }

  setBonusReserve(bonusReserve: number) {
    this.bonusReserveSubject.next(bonusReserve);
  }

  setBonusBalance(bonusBalance: number) {
    this.bonusBalanceSubject.next(bonusBalance);
  }

  setProfilePicture(profilePicture: string) {
    this.profilePictureSubject.next(profilePicture);
  }

  emitCreditAssignedSuccess() {
    this.creditAssignedSuccessSource.next();
  }
}
